// :cow: Cosmose CONFIDENTIAL :iso:
import { ExecutionTypes } from '@med/app/home/campaign/modules/execution//model/execution.model';
import { PlannerType } from '@med/app/home/campaign/model/planner-type';

export enum PATHS {
  Home = '',
  Login = 'login',
  ResetPassword = 'reset-password',
  Objective = 'objective',
  Settings = 'settings',
  ClientUserInvitation = 'invitations',
  Clients = 'clients',
  Campaign = 'campaign',
  AdSet = 'ad-set',
  Ad = 'ad',
  Dsp = 'dsp',
  AdSetNew = 'new',
  Execution = 'execution',
  Report = 'report',
  Summary = 'summary',
  Success = 'success',
  error500 = '500',
  error403 = '403',
  error404 = '404'
}

export const plannerRoutes = (campaignId?: number, step?: PlannerType): Record<string, string> => ({
  home: `/${PATHS.Campaign}/${campaignId}`,
  summary: `/${PATHS.Campaign}/${campaignId}/summary`,
  step: `/${PATHS.Campaign}/${campaignId}/${step}`,
  audienceCriteria: `/${PATHS.Campaign}/${campaignId}/${PlannerType.AudienceCriteria}`,
  targetGroupSpecification: `/${PATHS.Campaign}/${campaignId}/${PlannerType.TargetGroupSpecification}`,
  timeline: `/${PATHS.Campaign}/${campaignId}/${PlannerType.Timeline}`,
  budget: `/${PATHS.Campaign}/${campaignId}/${PlannerType.Budget}`,
  platform: `/${PATHS.Campaign}/${campaignId}/${PlannerType.Media}`
});

export const executionRoutes = (campaignId?: number, step?: ExecutionTypes): Record<string, string> => ({
  mobile: `/${PATHS.Campaign}/${campaignId}/execution/mobile`,
  home: `/${PATHS.Campaign}/${campaignId}/execution/`,
  step: `/${PATHS.Campaign}/${campaignId}/execution/${step}`,
  legalCensorship: `/${PATHS.Campaign}/${campaignId}/execution/${ExecutionTypes.LegalCensorship}`,
  creativeCensorship: `/${PATHS.Campaign}/${campaignId}/execution/${ExecutionTypes.CreativeCensorship}`,
  trackingCodes: `/${PATHS.Campaign}/${campaignId}/execution/${ExecutionTypes.TrackingCodes}`,
  adPreview: `/${PATHS.Campaign}/${campaignId}/execution/${ExecutionTypes.AdPreview}`
});

export const executionDspRoutes = (campaignId?: string, step?: ExecutionTypes): Record<string, string> => ({
  home: `/${PATHS.Dsp}/${campaignId}/execution/`,
  step: `/${PATHS.Dsp}/${campaignId}/execution/${step}`,
  legalCensorship: `/${PATHS.Dsp}/${campaignId}/execution/${ExecutionTypes.LegalCensorship}`,
  creativeCensorship: `/${PATHS.Dsp}/${campaignId}/execution/${ExecutionTypes.CreativeCensorship}`,
  trackingCodes: `/${PATHS.Dsp}/${campaignId}/execution/${ExecutionTypes.TrackingCodes}`,
  adPreview: `/${PATHS.Dsp}/${campaignId}/execution/${ExecutionTypes.AdPreview}`
});

export const campaignRoutes = (campaignId?: number): Record<string, string> => ({
  home: `/${PATHS.Campaign}`,
  campaign: `/${PATHS.Campaign}/${campaignId}`,
  success: `/${PATHS.Campaign}/${campaignId}/${PATHS.Success}`,
  report: `/${PATHS.Campaign}/${campaignId}/${PATHS.Report}`,
  execution: `/${PATHS.Campaign}/${campaignId}/${PATHS.Execution}`,
  summary: `/${PATHS.Campaign}/${campaignId}/${PATHS.Summary}`
});
